import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Container } from "@mui/material";

const MainLayout = ({ children }) => (
  <>
    <Navbar />
    <Container maxWidth="xl" sx={{ mt: 2, mb: 4 }}>
      {children}
    </Container>
    <Footer />
  </>
);

export default MainLayout;